import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import Drp_PickerCity from '../ProvinceCity/Drp_PickerCity.js';
import Auto_User from '../User/Auto_User.js';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import GetTax from '../Common/GetTax.js';
import PN from "persian-number";
import { Modal } from "react-bootstrap";



const InsertPreFactorIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const GetTaxRef = useRef()
    const UserRef = useRef()
    const CityRef = useRef()
    const [ErrorList, setErrorList] = useState([]);
    const [ErrorModal, setErrorModal] = useState(false);
    const [ItemList, setItemList] = useState([]);
    const [StoreList, setStoreList] = useState([]);
    const [ProductList, setProductList] = useState([]);
    const [HeaderId, setHeaderId] = useState(localStorage.getItem("PreFactorHeaderId"));
    const [Tax, setTax] = useState(0);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [ShowBuyPrice, setShowBuyPrice] = useState(localStorage.getItem("ShowBuyPrice"));
    const [Code, setCode] = useState("");

    const [CityId, setCityId] = useState(0);
    const [Print, setPrint] = useState(0);
    const [Reciept, setReciept] = useState(0);
    const [HasFactor, setHasFactor] = useState(0);
    const [StoreRoomId, setStoreRoomId] = useState(-1);
    const [StoreRoom, setStoreRoom] = useState("");
    const [LastBuyPrice, setLastBuyPrice] = useState(0);
    const [HeaderPrice, setHeaderPrice] = useState(0);
    const [DiscountType, setDiscountType] = useState(0);
    const [updatePrice, setupdatePrice] = useState(false);
    const [DiscountPrice, setDiscountPrice] = useState(0);
    // const [ItemTax, setItemTax] = useState(0);
    const [ItemDiscountPrice, setItemDiscountPrice] = useState(0);
    const [DiscountPercent, setDiscountPercent] = useState(0);

    const [SumItemPrice, setSumItemPrice] = useState(0);
    const [HeaderTax, setHeaderTax] = useState(0);
    const [FreightPrice, setFreightPrice] = useState(0);
    const [RegisterDate, setRegisterDate] = useState(moment(new Date())); // moment((new Date).format("jYYYY/jMM/jDD"))
    const [ReadOnlyRegisterDate, setReadOnlyRegisterDate] = useState("");
    const [CustomerId, setCustomerId] = useState(General.GuidEmpty());
    const [Customer, setCustomer] = useState("");
    const [FinancialBalance, setFinancialBalance] = useState("");
    const [Mobile, setMobile] = useState("");
    const [Address, setAddress] = useState("");
    const [Comment, setComment] = useState("");
    // const [Edited, setEdited] = useState(false);
    //#endregion



    const change_DiscountType = (e, checked) => {
        setDiscountType(checked == true ? 1 : 0)
    }


    const RegisterDate_Change = e => {
        setItemList([]);
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setRegisterDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const Change_FreightPrice = (e) => {
        setFreightPrice(PN.sliceNumber(e.replaceAll(',', '')));
        // var sumItemPrice = SumItemPrice;// != '0' ? SumItemPrice.toString().replaceAll(',', '') : 0
        // var itemDiscountPrice = ItemDiscountPrice;//  != '0' ? ItemDiscountPrice.toString().replaceAll(',', '') : 0
        var discountPrice = DiscountPrice != '0' ? DiscountPrice.toString().replaceAll(',', '') : 0
        // var headerTax = HeaderTax;// != '0' ? HeaderTax.toString().replaceAll(',', '') : 0
        var freightPrice = e > '0' ? e.replaceAll(',', '') : 0
        var SumTotalPrice = [...ItemList].filter(item => item.ProductId != General.GuidEmpty() && item.status != 'EDIT').map(o => o.TotalPrice).reduce((a, b) => a + b) * 1;
        var headerPrice = SumTotalPrice * 1 + freightPrice * 1 - discountPrice * 1
        setHeaderPrice(headerPrice);

        // setEdited(true);
    }
    const Change_DiscountPrice = (e) => {
        setDiscountPrice(PN.sliceNumber(e.replaceAll(',', '')));
        // var sumItemPrice = SumItemPrice;// != '0' ? SumItemPrice.toString().replaceAll(',', '') : 0
        // var itemDiscountPrice = ItemDiscountPrice;//  != '0' ? ItemDiscountPrice.toString().replaceAll(',', '') : 0
        var freightPrice = FreightPrice != '0' ? FreightPrice.toString().replaceAll(',', '') : 0
        // var headerTax = HeaderTax;// != '0' ? HeaderTax.toString().replaceAll(',', '') : 0
        var discountPrice = e > '0' ? e.replaceAll(',', '') : 0
        var SumTotalPrice = [...ItemList].filter(item => item.ProductId != General.GuidEmpty() && item.status != 'EDIT').map(o => o.TotalPrice).reduce((a, b) => a + b) * 1;
        // var headerPrice = sumItemPrice * 1 - itemDiscountPrice * 1 + headerTax * 1 + freightPrice * 1 - discountPrice * 1
        var headerPrice = SumTotalPrice * 1 + freightPrice * 1 - discountPrice * 1
        setHeaderPrice(headerPrice);

        // setEdited(true);
    }

    const User_Change = (e) => {
        setCustomerId(General.GuidEmpty())
        setCustomer("")
        setMobile("")
        setAddress("")
        setCityId(0)
        setFinancialBalance(0);


        if (e.split("|").length > 1) {
            setCustomer(e.split("|")[1]);
            setCustomerId(e.split("|")[0]);
            setFinancialBalance(e.split("|")[2] * 1 > 0);
            setMobile(e.split("|")[3]);
            setAddress(e.split("|")[4]);
            setCityId(e.split("|")[5] != -1 ? e.split("|")[5] * 1 : 0)
            CityRef.current.Select(e.split("|")[5] != -1 ? e.split("|")[5] * 1 : 0)
            // setTimeout(() => {
            // }, 200)

            return;
        }
        setMobile(e);
        UserRef.current.GetByMobile_Customer(e)
        CityRef.current.Select(-1)
    }

    const User_Select = (e) => {
        console.dir(e)
        setCustomer(e.split("|")[1]);
        setCustomerId(e.split("|")[0]);
        setFinancialBalance(e.split("|")[2] * 1 > 0);
        setMobile(e.split("|")[3]);
        setAddress(e.split("|")[4]);
        setCityId(e.split("|")[5] != -1 ? e.split("|")[5] * 1 : 0)
        CityRef.current.Select(e.split("|")[5] != -1 ? e.split("|")[5] * 1 : 0)


        return;
    }


    //#region Methods

    const BindByStoreId = (StoreId, title) => {

        var RequestOptions = {
            data: {
                'StoreRoomId': StoreId, 'Product': title
            },
            url: General.ApiRoute() + "/Product/SearchByStoreId",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var tmp = []
                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            value: result.data[i].identityNo == 0 ?
                                result.data[i].id + "|" + result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle + "|" + result.data[i].saleCount + "|" + result.data[i].lastBuyPrice + "|" + result.data[i].lastPrice :
                                result.data[i].id + "|" + result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle + " (" + result.data[i].identityNo + ")|" + result.data[i].saleCount + "|" + result.data[i].lastBuyPrice + "|" + result.data[i].lastPrice,
                            lable: result.data[i].identityNo == 0 ?
                                result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle :
                                result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle + " (" + result.data[i].identityNo + ")"
                            ,


                        })
                    }
                    setProductList(tmp)
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )



    }

    const BindStore = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/StoreRoom/GetAll', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        if (result[i].isActive == 1) {
                            tmp.push({
                                Row: i + 1,
                                Id: result[i].id,
                                Title: result[i].title,
                                Code: result[i].code,
                                IsActive: result[i].isActive,
                                IsDefault: result[i].isDefault,

                            })
                            if (result[i].isDefault == 1) {
                                setStoreRoom(result[i].title);
                                setStoreRoomId(result[i].id)
                            }

                        }
                    }
                    setStoreList(tmp)
                })
        )


    }

    const GetById = (headerId) => {
        trackPromise(
            fetch(General.ApiRoute() + '/PreFactor/GetHeaderById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': headerId
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setRegisterDate(moment(result.registerDate, 'jYYYY/jMM/jDD'))
                    setReadOnlyRegisterDate(result.registerDate)
                    setHeaderPrice(result.totalPrice);
                    setMobile(result.mobile);
                    setDiscountType(result.discountType);
                    setDiscountPrice(PN.sliceNumber(result.discountPrice));
                    setFreightPrice(PN.sliceNumber(result.freightPrice));
                    setDiscountPercent(result.discountPercent);
                    setCustomer(result.customer);
                    setCustomerId(result.customerId);
                    setCode(result.code);
                    setAddress(result.address);
                    setComment(result.comment);
                    setHeaderTax(result.itemTax);
                    setItemDiscountPrice(result.itemDiscountPrice);
                    setSumItemPrice(result.itemPrice)

                    var tax = 0;
                    if (result.children.length > 0) {
                        var tmp = [];

                        for (var i = 0; i < result.children.length; i++) {
                            // tax = tax + result.children[i].tax;
                            tmp.push({
                                row: i + 1,
                                ProductId: result.children[i].productId,
                                Product: result.children[i].product,
                                Editable: false,
                                Id: result.children[i].id,
                                status: "",
                                Count: result.children[i].count,
                                TotalPrice: result.children[i].totalPrice,
                                StoreRoomId: result.children[i].storeRoomId,
                                StoreRoom: result.children[i].storeRoom,
                                Price: result.children[i].price,
                                Tax: result.children[i].tax,
                                TransferType: result.children[i].transferType,
                                DiscountPrice: result.children[i].discountPrice,
                                LastBuyPrice: result.children[i].lastBuyPrice,
                                DiscountPercent: result.children[i].discountPercent,
                                RemainCount: result.children[i].remainCount,
                                // BuyPrice: 0,
                                DiscountType: result.children[i].discountType,

                            })
                        }
                        setItemList(tmp)
                        const firstInput = document.querySelector(
                            'input:not([disabled]), textarea, select'
                        );

                        firstInput?.focus();
                        // setHeaderTax(tax);
                    }


                })
        )
    }

    const Reset = () => {
        UserRef.current.focus();
        setItemList([]);
        setHeaderId(General.GuidEmpty());
        setCode("");
        setCustomer("");
        setComment("");
        setAddress("");
        setCustomerId(General.GuidEmpty());
        setMobile("");
        setLastBuyPrice(0);
        setHeaderPrice(0);
        setDiscountType(0);
        setDiscountPercent(0);
        setDiscountPrice(0);
        setSumItemPrice(0);
        setItemDiscountPrice(0);
        setHeaderTax(0);
        setFreightPrice(0);
        setRegisterDate(moment(new Date()));
        setReadOnlyRegisterDate("");
    }

    const Save = (hasFactor, print, reciept) => {
        setReciept(Reciept);
        setHasFactor(hasFactor);
        setPrint(print);

        if (RegisterDate == "" || RegisterDate == null) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن تاریخ پیش فاکتور اجباری می باشد")), 'topCenter')
            return;
        }

        if (Customer == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن نام مشتری اجباری می باشد")), 'topCenter')
            return;
        }
        if (Mobile == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن شماره همراه مشتری اجباری می باشد")), 'topCenter')
            return;
        }
        if (ItemList.length == 0 || (ItemList.length == 1 && ItemList[0].status != "EDIT")) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" لیست محصولات پیش فاکتور اجباری می باشد")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "Id": HeaderId,
                "CustomerId": CustomerId,
                "Customer": Customer,
                "Mobile": Mobile,
                "Address": Address,
                "CityId": CityId,
                "Comment": Comment,
                "RegisterDate": moment(RegisterDate.format()).format('jYYYY/jMM/jDD'),
                "HasFactor": HasFactor,
                "FiscalYearId": FiscalYearId,
                "FreightPrice": FreightPrice != "0" ? FreightPrice.replaceAll(",", "") : 0,
                "DiscountType": DiscountType ? 1 : 0,
                "DiscountPrice": DiscountPrice != "0" ? DiscountPrice.replaceAll(",", "") : 0,
                "ItemDiscountPrice": ItemDiscountPrice,//!= "0" ? ItemDiscountPrice.replaceAll(",", "") : 0,
                "ItemTax": HeaderTax,//!= "0" ? HeaderTax.replaceAll(",", "") : 0,
                "ItemPrice": SumItemPrice,//!= "0" ? SumItemPrice.replaceAll(",", "") : 0,
                "DiscountPercent": DiscountPercent,
                "TotalPrice": HeaderPrice,//!= "0" ? HeaderPrice.replaceAll(",", "") : 0,
                "Children": [...ItemList].filter(item => item.ProductId != General.GuidEmpty() && item.status != 'EDIT'),
            },
            url: General.ApiRoute() + "/PreFactor/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json',
                'UpdatePrice': updatePrice
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data.length > 0) {

                        if (result.data[result.data.length - 1].title.includes("OK")) {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                            if (result.data.length > 1) {
                                setErrorList(result.data);
                                setErrorModal(true);
                            }

                            if (hasFactor == 0) {

                                if (print == 0 && reciept == 0) {
                                    if (HeaderId == General.GuidEmpty()) {
                                        Reset();
                                        localStorage.removeItem("PreFactorHeaderId");
                                    }
                                    else {
                                        localStorage.removeItem("PreFactorHeaderId");
                                    }
                                    if (result.data.length == 1)
                                        SetOKError(hasFactor, print, reciept);
                                }
                                else if (print == 1) {
                                    localStorage.setItem("PreFactorHeaderId", HeaderId == General.GuidEmpty() ? result.data.filter(x => x.title.toLowerCase().includes("ok"))[0].comment.split("|")[0] : HeaderId);
                                    // localStorage.setItem("BackPage", "InsertPrefactor");
                                    if (result.data.length == 1)
                                        SetOKError(hasFactor, print, reciept);
                                }
                                else if (reciept == 1) {
                                    localStorage.setItem("PreFactorHeaderId", HeaderId == General.GuidEmpty() ? result.data.filter(x => x.title.toLowerCase().includes("ok"))[0].comment.split("|")[0] : HeaderId);
                                    localStorage.setItem("BackPage", "InsertPrefactor");
                                    if (result.data.length == 1)
                                        SetOKError(hasFactor, print, reciept);
                                }
                            }
                            else {
                                localStorage.setItem("FactorHeaderId", result.data.filter(x => x.title.toLowerCase().includes("ok"))[0].comment.split("|")[1]);
                                localStorage.setItem("BackPage", "InsertPrefactor");
                                toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است. شماره فاکتور :" + result.data.filter(x => x.title.includes("ok"))[0].comment.split("|")[2])), 'topCenter')
                                if (result.data.length == 1)
                                    SetOKError(hasFactor, print, reciept);

                            }
                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data.filter(x => x.title.toLowerCase().includes("error")[0].comment))), 'topCenter')

                        }
                    }

                }).catch((error) => {
                    console.dir(error);
                    console.dir(error);
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const SetOKError = (hasFactor, print, reciept) => {
        setErrorList([]);
        setErrorModal(false);
        if (hasFactor == 0) {
            if (print == 0 && reciept == 0) {
                if (HeaderId == General.GuidEmpty()) {
                    Reset();
                }
                else {
                    navigate("/PreFactor")
                }
            }
            else if (print == 1) {
                // navigate("/PrintPreFactor")
                window.open("/PrintPreFactor", "_blank");

            }
            else if (reciept == 1) {
                navigate("/PreReciept")
            }
        }
        else {
            navigate("/InsertPreReciept")
        }
    }

    const onEditItem = (row) => {

        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            temp[index].status = "EDIT";
            temp[index].Tax = PN.sliceNumber(temp[index].Tax);
            temp[index].Price = PN.sliceNumber(temp[index].Price);
            temp[index].TotalPrice = PN.sliceNumber(temp[index].TotalPrice);
            temp[index].DiscountPrice = PN.sliceNumber(temp[index].DiscountPrice);


        }
        setItemList(temp);
    }

    const NewItem = () => {
        setProductList([]);
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.status == "EDIT");
        if (index == -1) {
            temp.push(
                {
                    row: ItemList.length + 1,
                    ProductId: General.GuidEmpty(),
                    Product: '',
                    Editable: true,
                    Id: General.GuidEmpty(),
                    status: "EDIT",
                    Count: 0,
                    TotalPrice: 0,
                    StoreRoomId: StoreRoomId,
                    StoreRoom: StoreRoom,
                    Price: 0,
                    Tax: 0,
                    TransferType: 1,
                    DiscountPrice: 0,
                    DiscountPercent: 0,
                    RemainCount: 0,
                    LastBuyPrice: 0,
                    // BuyPrice: 0,
                    DiscountType: DiscountType,
                });
            setItemList(temp)
            setTimeout(() => {
                const inputElement = document.querySelector('.FocusItem');
                if (inputElement) {
                    inputElement.focus();
                }

            }, 200)

        }
    }

    const Change_Item = (row, dataType, value, text = "") => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            var price = temp[index].Price > '0' ? temp[index].Price.replaceAll(",", "") : 0
            var discountPrice = temp[index].DiscountPrice > '0' ? temp[index].DiscountPrice.replaceAll(",", "") : 0
            var discountPercent = temp[index].DiscountPercent;
            var tax = temp[index].Tax > '0' ? temp[index].Tax.replaceAll(",", "") : 0
            var totalPrice = 0;

            if (dataType == "Price") {
                price = value != "0" && value != 0 ? value.replaceAll(',', '') : 0;
                discountPrice = DiscountType == 1 ? Math.trunc(price * temp[index].DiscountPercent * 1 / 100) : discountPrice;
                discountPercent = DiscountType == 1 ? temp[index].DiscountPercent : Number.parseFloat(discountPrice * 100 / price).toFixed(2);
                // discountPercent = DiscountType == 1 ? temp[index].DiscountPercent : Math.round((discountPrice * 100 / price) * 100 / 100, 2);

                tax = Math.trunc((price * 1 - discountPrice * 1) * Tax * 1 / 100);

                totalPrice = Math.trunc((price * 1 + tax * 1 - discountPrice * 1) * temp[index].Count * 1);
                temp[index].DiscountPrice = PN.sliceNumber(discountPrice);
                temp[index].DiscountPercent = discountPercent;
                temp[index].Price = PN.sliceNumber(price);
                temp[index].TotalPrice = PN.sliceNumber(totalPrice);
                temp[index].Tax = PN.sliceNumber(tax);
            }
            else if (dataType == "Count") {
                temp[index].Count = value * 1;
                totalPrice = Math.trunc((price * 1 + tax * 1 - discountPrice * 1) * value * 1);
                temp[index].TotalPrice = PN.sliceNumber(totalPrice);
            }
            else if (dataType == "DiscountPrice") {
                discountPrice = value != "0" && value != 0 ? value.replaceAll(',', '') : 0;
                discountPercent = Number.parseFloat(discountPrice * 1 * 100 / price * 1).toFixed(2);
                tax = Math.trunc((price * 1 - discountPrice * 1) * Tax * 1 / 100);
                totalPrice = Math.trunc((price * 1 + tax * 1 - discountPrice * 1) * temp[index].Count * 1);
                temp[index].DiscountPrice = PN.sliceNumber(discountPrice);
                temp[index].DiscountPercent = discountPercent;
                temp[index].TotalPrice = PN.sliceNumber(totalPrice);
                temp[index].Tax = PN.sliceNumber(tax);
            }

            else if (dataType == "DiscountPercent") {
                discountPercent = value;
                discountPrice = Math.trunc(value * price / 100);
                tax = Math.trunc((price * 1 - discountPrice * 1) * Tax * 1 / 100);
                totalPrice = Math.trunc((price * 1 + tax * 1 - discountPrice * 1) * temp[index].Count);
                temp[index].DiscountPrice = PN.sliceNumber(discountPrice);
                temp[index].DiscountPercent = discountPercent;
                temp[index].TotalPrice = PN.sliceNumber(totalPrice);
                temp[index].Tax = PN.sliceNumber(tax);
            }

            else if (dataType == "StoreRoom" && value != undefined) {

                if (temp[index].StoreRoomId != value && temp[index].StoreRoomId != -1) {
                    temp[index].ProductId = General.GuidEmpty();
                    temp[index].Product = "";
                    temp[index].RemainCount = 0;
                    temp[index].Price = 0;
                    temp[index].Tax = 0;
                    temp[index].LastBuyPrice = 0;
                    BindByStoreId(value, "")

                }
                temp[index].StoreRoomId = value * 1;
                temp[index].StoreRoom = text;


            }
            else if (dataType == "Product" && value != undefined) {
                temp[index].ProductId = General.GuidEmpty();
                if (value.indexOf("|") > 1) {
                    temp[index].Product = value.split("|")[1];
                    temp[index].RemainCount = value.split("|")[2] == "undefined" ? 0 : value.split("|")[2] * 1;
                    temp[index].Price = PN.sliceNumber(value.split("|")[4]);
                    temp[index].Tax = PN.sliceNumber(Math.trunc(value.split("|")[4] * 1 * Tax / 100));
                    temp[index].TotalPrice = PN.sliceNumber(value.split("|")[4] * 1 + Math.trunc(value.split("|")[4] * 1 * Tax / 100));
                    temp[index].LastBuyPrice = value.split("|")[3] * 1;
                    temp[index].ProductId = value.split("|")[0];

                    setTimeout(() => {
                        temp[index].Count = 1;


                    }, 200)
                    return;
                }
                else {
                    temp[index].Product = value;
                    temp[index].RemainCount = 0;
                    temp[index].LastBuyPrice = 0;
                    temp[index].TotalPrice = 0;
                    temp[index].Price = 0;
                    temp[index].Tax = 0;
                    BindByStoreId(temp[index].StoreRoomId, value)


                }
            }
            else if (dataType == "TransferType") {
                temp[index].TransferType = value * 1;
            }

            setItemList(temp);
        }
    }

    const Select_Item = (row, dataType, value) => {

        var temp = [...ItemList];

        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            temp[index].Product = value.split("|")[1];
            temp[index].RemainCount = value.split("|")[2] == "undefined" ? 0 : value.split("|")[2] * 1;
            temp[index].Price = PN.sliceNumber(value.split("|")[4]);
            temp[index].Tax = PN.sliceNumber(Math.trunc(value.split("|")[4] * 1 * Tax / 100));
            temp[index].TotalPrice = PN.sliceNumber(value.split("|")[4] * 1 + Math.trunc(value.split("|")[4] * 1 * Tax / 100));
            temp[index].LastBuyPrice = value.split("|")[3] * 1;
            temp[index].ProductId = value.split("|")[0];




            setTimeout(() => {
                const inputElement = document.querySelector('.CountItem');
                if (inputElement) {
                    inputElement.focus();

                }
                temp[index].Count = 1;
                setItemList(temp);


            }, 200)
        }

    }

    const SaveItem = (row) => {
        // setEdited(true);
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            if (temp[index].Price == "0" || temp[index].Price == 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("قیمت محصول اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].Count == "0" || temp[index].Count == 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("تعداد محصول اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].ProductId == General.GuidEmpty()) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب محصول اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].StoreRoomId == -1) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب انبار اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].TransferType == -1) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب نوع فروش اجباری می باشد")), 'topCenter')
                return;
            }
            else {
                temp[index].status = "";
                temp[index].Tax = temp[index].Tax != "0" && temp[index].Tax != 0 ? temp[index].Tax.replaceAll(',', '') * 1 : 0;
                temp[index].Price = temp[index].Price != "0" && temp[index].Price != 0 ? temp[index].Price.replaceAll(',', '') * 1 : 0;
                temp[index].TotalPrice = temp[index].TotalPrice != "0" && temp[index].TotalPrice != 0 ? temp[index].TotalPrice.replaceAll(',', '') * 1 : 0;
                temp[index].DiscountPrice = temp[index].DiscountPrice != "0" && temp[index].DiscountPrice != 0 ? temp[index].DiscountPrice.replaceAll(',', '') * 1 : 0;
                var freightPrice = FreightPrice > '0' ? FreightPrice.replaceAll(',', '') : 0
                var discountPrice = DiscountPrice > '0' ? DiscountPrice.replaceAll(',', '') : 0
                setHeaderTax(temp.map(o => o.Tax * o.Count).reduce((a, b) => a + b));
                setItemDiscountPrice(temp.map(o => o.DiscountPrice * o.Count).reduce((a, b) => a + b));
                setSumItemPrice(temp.map(o => o.Price * o.Count).reduce((a, b) => a + b));
                setHeaderPrice(temp.map(o => o.TotalPrice).reduce((a, b) => a + b) * 1 + freightPrice * 1 - discountPrice * 1);
                if (temp.filter(item => item.ProductId == General.GuidEmpty()).length == 0)
                    temp.push({
                        row: ItemList.length + 1,
                        ProductId: General.GuidEmpty(),
                        Product: '',
                        Editable: true,
                        Id: General.GuidEmpty(),
                        status: "EDIT",
                        Count: 0,
                        TotalPrice: 0,
                        StoreRoomId: StoreRoomId,
                        StoreRoom: StoreRoom,
                        Price: 0,
                        Tax: 0,
                        TransferType: 1,
                        DiscountPrice: 0,
                        LastBuyPrice: 0,
                        DiscountPercent: 0,
                        RemainCount: 0,
                        // BuyPrice: 0,
                        DiscountType: DiscountType,
                    })
                setItemList(temp);

                setTimeout(() => {


                    const inputElement = document.querySelector('.FocusItem');
                    if (inputElement) {
                        inputElement.focus();

                    }
                    setTimeout(() => {
                        BindByStoreId(temp[temp.length - 1]["StoreRoomId"], "");
                    }, 200)
                }, 200)
            }

        }


    }

    const DeleteItem = (row) => {

        // setEdited(true);
        var temp = [...ItemList.filter(item => item.row !== row)];
        setItemList(temp);
        var freightPrice = FreightPrice > '0' ? FreightPrice.replaceAll(',', '') : 0
        var discountPrice = DiscountPrice > '0' ? DiscountPrice.replaceAll(',', '') : 0
        if (temp.length > 0) {
            setHeaderTax(temp.map(o => o.Tax * o.Count).reduce((a, b) => a + b));
            setItemDiscountPrice(temp.map(o => o.DiscountPrice * o.Count).reduce((a, b) => a + b));
            setSumItemPrice(temp.map(o => o.Price * o.Count).reduce((a, b) => a + b));
            setHeaderPrice(temp.map(o => o.TotalPrice).reduce((a, b) => a + b) * 1 + freightPrice * 1 - discountPrice * 1);

        }
        else {
            setHeaderTax(0);
            setItemDiscountPrice(0);
            setSumItemPrice(0);
            setHeaderPrice(freightPrice);

        }
        const inputElement = document.querySelector('.FocusBtn');
        if (inputElement) {
            inputElement.focus();
        }


    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 21);
        myHeaders.append("Operation", HeaderId != General.GuidEmpty() ? 3 : 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        if (localStorage.getItem("PreFactorHeaderId") != undefined && localStorage.getItem("PreFactorHeaderId") != General.GuidEmpty()) {
                            GetById(localStorage.getItem("PreFactorHeaderId"));
                            setHeaderId(localStorage.getItem("PreFactorHeaderId"))
                        }
                        GetTaxRef.current.Get();
                        UserRef.current.GetByMobile_Customer("")
                        CityRef.current.Bind(0, "")
                        BindStore();

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const handelKeyDown = (e) => {
        if (e.key == "Enter") {

            if ([...ItemList].length > 0) {
                var index = [...ItemList].findIndex(x => x.status == "EDIT");
                if (index != -1) {
                    SaveItem([...ItemList][index].row);
                    return;
                }
                else {
                    NewItem();
                    return;

                }
            }
            else {
                NewItem();
            }
        }
        if (e.key == "Delete") {
            var index = [...ItemList].findIndex(x => x.status == "EDIT");

            if (index != -1)
                DeleteItem([...ItemList][index].row);
            else if ([...ItemList].length > 0)
                DeleteItem([...ItemList][[...ItemList].length - 1].row);
        }


        if (e.key == "Escape") {
            localStorage.removeItem("PreFactorHeaderId");
            navigate("/PreFactor")
        }

        if (e.shiftKey && e.code === "KeyS") {
            Save(0, 0, 0);
        }

        if (e.shiftKey && e.code === 'KeyF') {
            Save(1, 0, 0);
        }
        if (e.shiftKey && e.code === 'KeyR' && localStorage.getItem("PreReciept_License") == "1") {
            Save(0, 0, 1);
        }
        if (e.shiftKey && e.code === 'KeyP') {
            Save(0, 1, 0);
        }
        if (e.shiftKey && e.code === 'KeyN') {
            Reset();
        }
    }

    useEffect(() => {
        CheckPermission();
        document.title = "پیش فاکتور ";
        UserRef.current.focus();
    }, [])
    //#endregion



    return (

        <Layout title="ثبت پیش فاکتور ">
            <div className="h-100 p-1" onKeyDown={handelKeyDown} >
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={() => Save(0, 0, 0)}>  ثبت</rsuite.Button>
                                <rsuite.Button appearance="primary" size="xs" className={localStorage.getItem("PreReciept_License") == "1" ? "m-1" : "hide"} onClick={() => Save(0, 0, 1)}>  ثبت پیش فاکتور و پیش پرداخت</rsuite.Button>
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={() => Save(0, 1, 0)}>  ثبت پیش فاکتور و پرینت</rsuite.Button>
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={() => Save(1, 0, 0)}>  ثبت و تبدیل به فاکتور</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={Reset}>  جـــدید</rsuite.Button>
                                <rsuite.Button appearance="primary" color="yellow" size="xs" className="m-1" onClick={() => (localStorage.removeItem("PreFactorHeaderId"), navigate("/PreFactor"))}>  بازگشت</rsuite.Button>
                                <GetTax ref={GetTaxRef} onSubmit={(value) => setTax(value)} />
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={localStorage.getItem("PreFactor_Discount") == "1" ? "" : "hide"}>
                            <rsuite.Checkbox onChange={(e, checked) => change_DiscountType(e, checked)} checked={DiscountType} value={DiscountType} /> &nbsp;    تخفیف به درصد می باشد
                            <br />  <rsuite.Checkbox onChange={(e, checked) => setupdatePrice(checked)} checked={updatePrice} value={updatePrice} /> &nbsp;    قیمت ها به روز شود. <b className='text-danger text-decoration-underline'> در صورت به روز رسانی قیمت ها، قیمت در وب سایت نبز به روز می شود</b>
                        </rsuite.Col>

                        <rsuite.Col xxl={16} xl={16} lg={16} md={16} sm={12} xs={24}>
                            <label>شماره پیش فاکتور</label>
                            <rsuite.Input disabled value={Code} onChange={(e) => setCode(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label> تاریخ </label>
                            {HeaderId == General.GuidEmpty() ?
                                <DatePicker className="rs-input " isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={RegisterDate} onChange={RegisterDate_Change} />
                                :
                                <rsuite.Input disabled value={ReadOnlyRegisterDate} />
                            }

                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>شماره همراه مشتری </label>
                            <Auto_User className="FocusItem " disabled={HeaderId == General.GuidEmpty() ? false : true} value={Mobile} onChange={User_Change} onSelect={User_Select} ref={UserRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label> نام و نام خانوادگی </label>
                            {/* , setEdited(true) */}
                            <rsuite.Input value={Customer} onChange={(e) => (setCustomer(e))} />
                        </rsuite.Col>

                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <label> شهر</label>
                            {/* , setEdited(true) */}
                            <Drp_PickerCity value={CityId} onChange={(value, title) => (setCityId(value))} ref={CityRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={16} xl={16} lg={16} md={16} sm={24} xs={24}>
                            <label> آدرس</label>
                            {/* , setEdited(true) */}
                            <rsuite.Input value={Address} onChange={(e) => (setAddress(e))} />
                        </rsuite.Col>


                    </rsuite.Row>
                    <hr />

                    <rsuite.Row className="p-1 mb-5 pb-5" >
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Button className='FocusBtn' appearance="primary" color="green" size='xs'
                                onClick={() => NewItem()}>
                                اضافه شدن محصول جدید
                            </rsuite.Button>
                        </rsuite.Col>

                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>


                            <rsuite.Table height={320} data={ItemList} rowHeight={80} wordWrap>
                                <rsuite.Table.Column width={50} align="center"  >
                                    <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey="row">
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                                <rsuite.Table.Column flexGrow={2} fullText resizable>
                                    <rsuite.Table.HeaderCell>نوع فروش</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >

                                        {(rowData, rowIndex) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (


                                                    <select className="rs-input FocusItem" value={rowData.TransferType}
                                                        // onKeyDown={(e) => handelKeyDown(e, "TransferType")}
                                                        onChange={value => {
                                                            Change_Item?.(rowData.row, "TransferType", value.target.value);
                                                        }}>
                                                        <option value="-1">انتخاب نمایید</option>
                                                        <option value="1">ارسال شده است</option>
                                                        <option value="2">باید ارسال شود</option>
                                                    </select>


                                                ) : (
                                                    <text>
                                                        {rowData.TransferType == 1 ? "ارسال شده است" :
                                                            rowData.TransferType == 2 ? "باید ارسال شود" :
                                                                ""}
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>



                                </rsuite.Table.Column>

                                <rsuite.Table.Column flexGrow={2} fullText resizable>
                                    <rsuite.Table.HeaderCell>انبار </rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >

                                        {(rowData, rowIndex) => {
                                            return <>


                                                {rowData.status == 'EDIT' ? (
                                                    <select className="rs-input StoreRoom" onChange={(event) => { Change_Item?.(rowData.row, "StoreRoom", event.target.value, event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text) }} value={rowData.StoreRoomId}>
                                                        <option value="-1">انتخاب نمایید</option>
                                                        {
                                                            StoreList.map(item => (
                                                                <option value={item.Id}> {item.Title} ({item.Code})  </option>
                                                            ))
                                                        }

                                                    </select>
                                                ) : (
                                                    <text>
                                                        {rowData.StoreRoom}
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>



                                </rsuite.Table.Column>


                                <rsuite.Table.Column width={250} >
                                    <rsuite.Table.HeaderCell>محصول </rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >


                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>
                                                        <rsuite.Badge color={rowData.RemainCount > 0 ? 'green' : "red"} content={" قابل فروش :" + rowData.RemainCount}>




                                                            <rsuite.AutoComplete //style={{ width: "200px"  }}
                                                                data={ProductList.map((product) => ({
                                                                    label: `${product.lable}`,
                                                                    value: `${product.value}`,
                                                                }))}
                                                                value={rowData.Product}
                                                                key={rowData.row}
                                                                filterBy={(item, input) => {
                                                                    const normalizeText = (Text) => {
                                                                        if (typeof (Text) == "string")
                                                                            return Text.toLowerCase();
                                                                        else
                                                                            return "";
                                                                    }
                                                                    return normalizeText(item?.label).includes(normalizeText(input || ""));
                                                                }}
                                                                renderMenuItem={(label, item) => <span>{item?.label}</span>}
                                                                renderValue={(value, item) => (item ? item.label : "")}
                                                                onChange={value => { Change_Item?.(rowData.row, "Product", value); }}
                                                                onSelect={value => { Select_Item?.(rowData.row, "Product", value); }}
                                                                placeholder='محصول'
                                                                // virtualized={false}
                                                                width={250}
                                                            />

                                                        </rsuite.Badge>
                                                        <rsuite.Text className={ShowBuyPrice == 1 ? 'Font10 float-start' : "hide"} as='sub'>قیمت خرید :  {rowData.LastBuyPrice != "0" ? <>{PN.sliceNumber(rowData.LastBuyPrice)} &nbsp;&nbsp;&nbsp;&nbsp; {PN.convert(rowData.LastBuyPrice)} ریال</> : ""}</rsuite.Text>

                                                    </>

                                                ) : (
                                                    <text>

                                                        {rowData.Product}
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>



                                </rsuite.Table.Column>


                                <rsuite.Table.Column flexGrow={1} >
                                    <rsuite.Table.HeaderCell>تعداد</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell  >
                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (

                                                    <rsuite.Input className='CountItem' value={rowData.Count} onChange={value => {
                                                        Change_Item?.(rowData.row, "Count", value);
                                                    }} />

                                                ) : (
                                                    <text>

                                                        {rowData.Count}
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>


                                <rsuite.Table.Column flexGrow={2} >
                                    <rsuite.Table.HeaderCell>قیمت واحد (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>

                                                        <rsuite.Input value={rowData.Price} onChange={value => {
                                                            Change_Item?.(rowData.row, "Price", value);
                                                        }}

                                                        />
                                                        <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                    </>

                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.Price)}
                                                        <br />
                                                        <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text>

                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                                {DiscountType != 0 && localStorage.getItem("PreFactor_Discount") == "1" ?
                                    <rsuite.Table.Column flexGrow={1} >
                                        <rsuite.Table.HeaderCell>تخفیف (%)</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >
                                            {(rowData) => {
                                                return <>
                                                    {rowData.status == 'EDIT' ? (
                                                        <>

                                                            <rsuite.Input disabled={DiscountType == 0 ? true : false} value={rowData.DiscountPercent} onChange={value => {
                                                                Change_Item?.(rowData.row, "DiscountPercent", value);
                                                            }}

                                                            />
                                                        </>

                                                    ) : (
                                                        <text>
                                                            {rowData.DiscountPercent}

                                                        </text>
                                                    )}
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    : <></>}
                                {localStorage.getItem("PreFactor_Discount") == "1" ?
                                    <rsuite.Table.Column flexGrow={2} >
                                        <rsuite.Table.HeaderCell>تخفیف واحد (ریال)</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >
                                            {(rowData) => {
                                                return <>
                                                    {rowData.status == 'EDIT' ? (
                                                        <>

                                                            <rsuite.Input disabled={DiscountType == 1 ? true : false} value={rowData.DiscountPrice} onChange={value => {
                                                                Change_Item?.(rowData.row, "DiscountPrice", value);
                                                            }}

                                                            />
                                                            <rsuite.Text className='Font10 float-start' as='sub'>{rowData.DiscountPrice != "0" ? <>{PN.convert(rowData.DiscountPrice.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                        </>

                                                    ) : (
                                                        <text>
                                                            {PN.sliceNumber(rowData.DiscountPrice)}
                                                            <br /><rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.DiscountPrice)} ریال</> : ""}</rsuite.Text>

                                                        </text>
                                                    )}
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    : <></>
                                }
                                {Tax != 0 ?
                                    <rsuite.Table.Column flexGrow={2} >
                                        <rsuite.Table.HeaderCell>مالیات واحد (ریال)</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >
                                            {(rowData) => {
                                                return <>
                                                    {rowData.status == 'EDIT' ? (
                                                        <>

                                                            <rsuite.Input disabled value={rowData.Tax} />
                                                            <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Tax != "0" ? <>{PN.convert(rowData.Tax.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                        </>

                                                    ) : (
                                                        <text>
                                                            {PN.sliceNumber(rowData.Tax)}
                                                            <br /><rsuite.Text className='Font10 float-start' as='sub'>{rowData.Tax != "0" ? <>{PN.convert(rowData.Tax)} ریال</> : ""}</rsuite.Text>

                                                        </text>
                                                    )}
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    : <></>}


                                <rsuite.Table.Column flexGrow={2} >
                                    <rsuite.Table.HeaderCell>قیمت کل (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell>
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>
                                                        <rsuite.Input value={rowData.TotalPrice} disabled />
                                                        <rsuite.Text className='Font10 float-start' as='sub'>{rowData.TotalPrice != "0" ? <>{PN.convert(rowData.TotalPrice.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                    </>
                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.TotalPrice)}
                                                        <br /><rsuite.Text className='Font10 float-start' as='sub'>{rowData.TotalPrice != "0" ? <>{PN.convert(rowData.TotalPrice)} ریال</> : ""}</rsuite.Text>

                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>

                                <rsuite.Table.Column width={100} fixed='right'>
                                    <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell>
                                        {(rowData) => {
                                            return <>


                                                {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                    :
                                                    <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                }
                                                &nbsp;&nbsp;&nbsp;
                                                <BiIcon.BiTrash onClick={() => DeleteItem(rowData.row)} className='fs-6 text-danger Cursor' />
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                            </rsuite.Table>



                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />
                    <rsuite.Row className='p-1   pt-5 mt-5 '>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <label> توضیحات</label>
                            {/* , setEdited(true) */}
                            <rsuite.Input value={Comment} onChange={(e) => (setComment(e))} />
                        </rsuite.Col>
                        <rsuite.Col xxl={18} xl={18} lg={18} md={18} sm={24} xs={24}>
                            <rsuite.Row>
                                <rsuite.Col xxl={13} xl={13} lg={13} md={13} sm={24} xs={24} className='mt-2'>
                                    <label>هزینه باربری (ریال)</label>
                                    <rsuite.Input value={FreightPrice} onChange={Change_FreightPrice} />
                                    <rsuite.Text className='Font10 float-start' as='sub'>{FreightPrice != "0" ? <>{PN.convert(FreightPrice.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>
                                <rsuite.Col xxl={13} xl={13} lg={13} md={13} sm={24} xs={24} className='mt-2'>
                                    <label> تخفیف کل (ریال)</label>
                                    <rsuite.Input value={DiscountPrice} onChange={Change_DiscountPrice} />
                                    <rsuite.Text className='Font10 float-start' as='sub'>{DiscountPrice != "0" ? <>{PN.convert(DiscountPrice.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                                    <b> تعداد اقلام فاکتور : </b>{ItemList.length == 0 ? 0 : ItemList.map(o => o.Count).reduce((a, b) => a + b)}
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2'>
                                    <b>تخفیف کل : </b> {DiscountPrice != "0" ? PN.sliceNumber(DiscountPrice.replaceAll(',', '') * 1 + ItemDiscountPrice * 1) :
                                        PN.sliceNumber(ItemDiscountPrice * 1)} ریال
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>
                                        {DiscountPrice != "0" ? <>{PN.convert(DiscountPrice.replaceAll(',', '') * 1 + ItemDiscountPrice * 1)} ریال</> :
                                            ItemDiscountPrice != 0 ? <>{PN.convert(ItemDiscountPrice * 1)}  ریال </> : ""}</rsuite.Text>

                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={Tax == 0 ? "hide" : "mt-2"} >
                                    <b>مالیات کل : </b> {PN.sliceNumber(HeaderTax)} ریال
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderTax != "0" ? <>{PN.convert(HeaderTax)} ریال</> : ""}</rsuite.Text>

                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                                    <b>قیمت قبل از تخفیف : </b> <text> {DiscountPrice != "0" ? PN.sliceNumber(HeaderPrice * 1 + DiscountPrice.replaceAll(',', '') * 1 + ItemDiscountPrice * 1) : PN.sliceNumber(HeaderPrice * 1 + ItemDiscountPrice * 1)}   ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderPrice != "0" ?
                                        <>{DiscountPrice != "0" ? PN.convert(HeaderPrice * 1 + DiscountPrice * 1 + ItemDiscountPrice * 1)
                                            : PN.convert(HeaderPrice * 1 + ItemDiscountPrice * 1)} ریال</> : ""}</rsuite.Text>

                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                                    <b>قیمت قابل پرداخت : </b> <text>  {PN.sliceNumber(HeaderPrice * 1)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderPrice != "0" ? <>{PN.convert(HeaderPrice * 1)} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>

                            </rsuite.Row>
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24} className={FinancialBalance > 0 ? 'alert alert-success Font17' : FinancialBalance < 0 ? 'alert alert-danger Font17' : ""} >
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <b className='Font17'> باقیمانده حساب</b>
                            <br />
                            <br />
                            <text className='Font17'>
                                {FinancialBalance > 0 ?
                                    <p> {PN.sliceNumber(FinancialBalance)} ریال بستانکار
                                        <br /><rsuite.Text className='Font10' as='sub'>{PN.convert(FinancialBalance.toString().replaceAll(',', ''))} ریال</rsuite.Text>
                                    </p>
                                    : FinancialBalance < 0 ?
                                        <p> {PN.sliceNumber(FinancialBalance * (-1))} ریال بدهکار
                                            <br /><rsuite.Text className='Font10' as='sub'>{PN.convert((FinancialBalance * (-1)).toString().replaceAll(',', ''))} ریال</rsuite.Text>
                                        </p>

                                        :
                                        " 0 ریال"}
                            </text>
                        </rsuite.Col>


                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>

                            <small><b>Enter : </b> اضافه شدن محصول جدید <b> | Tab : </b>  جابه جایی در ستون رو به جلو <b>| Shift+Tab :</b> جابه جایی در ستون رو به عقب <b>| Delete :</b> حذف ستون <b>| Enter :</b> اضافه شدن ستون
                                <b>| ESC :</b> بازگشت به صفحه قبل
                                <b>| Shift+s :</b> ثبت نهایی پیش فاکتور
                                <b>| Shift+f :</b> ثبت نهایی پیش فاکتور و تبدیل به فاکتور
                                <text className={localStorage.getItem("PreReciept_License") == "1" ? "m-1" : "hide"}> <b>| Shift+r :</b> ثبت نهایی پیش فاکتور و پیش پرداخت </text>
                                <b>| Shift+p :</b> ثبت نهایی پیش فاکتور و پرینت
                                <b>| Shift+N :</b> جدید
                            </small>
                        </rsuite.Col>
                    </rsuite.Row>
                </rsuite.Panel >
            </div >
            <Modal show={ErrorModal} onHide={() => SetOKError(HasFactor, Print, Reciept)} size="xl" backdrop="static" keyboard={false}>
                <Modal.Header >

                    <Modal.Title className='fs-5'>شرح خطا</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>

                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Table
                                    height={500}
                                    data={ErrorList}
                                    wordWrap="break-word"
                                >
                                    <rsuite.Table.Column flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell> توضیحات </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.validation == false ?
                                                        <p className='text-danger'>{rowData.comment}</p>
                                                        : !rowData.title.includes('OK') ? <p>{rowData.comment}</p>
                                                            :
                                                            <></>
                                                    }
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                </rsuite.Table>
                            </rsuite.Col>
                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>

                    <rsuite.Button appearance="subtle" onClick={() => SetOKError(HasFactor, Print, Reciept)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>


        </Layout >


    )
}

export default InsertPreFactorIndex;